/*Sidebar*/

import i_vias from './../UI/icons/Sidebar/Vias.svg'
import i_vias2 from './../UI/icons/Sidebar/Vias2.svg'
import i_beneficios from './../UI/icons/Sidebar/Puntos-interes.svg'
import i_beneficios2 from './../UI/icons/Sidebar/Puntos-interes2.svg'
import i_amenidades from './../UI/icons/Sidebar/Amenidades2.svg'
import i_amenidades2 from './../UI/icons/Sidebar/Amenidades.svg'
import i_entretenimiento from './../UI/icons/Sidebar/entretenimiento2.svg'
import i_entretenimiento2 from './../UI/icons/Sidebar/entretenimiento.svg'
import i_etapas from './../UI/icons/Sidebar/Proyecto.svg'
import i_etapas2 from './../UI/icons/Sidebar/Proyecto2.svg'

import i_renders from './../UI/icons/Galerias/renders.svg'
import i_recor from './../UI/icons/Galerias/360.svg'
import i_back from './../UI/icons/back-btn.svg'

/*Proyecto Casa Ambar*/
import i_planimetria from './../UI/icons/proyecto/planimetria.svg'
import i_planimetria2 from './../UI/icons/proyecto/planimetria2.svg'
import i_presentacion from './../UI/icons/proyecto/presentacion.svg'
import i_presentacion2 from './../UI/icons/proyecto/presentacion2.svg'
import i_videos from './../UI/icons/proyecto/video.svg'
import i_videos2 from './../UI/icons/proyecto/video2.svg'
import i_proyecto from './../UI/icons/CasaIndigo/proyectos2.svg'
import i_proyecto2 from './../UI/icons/CasaIndigo/proyectos.svg'
import i_brochure from './../UI/icons/proyecto/download.svg'
import i_brochure2 from './../UI/icons/proyecto/download2.svg'
import i_contacto from './../UI/icons/proyecto/contact.svg'
import i_contacto2 from './../UI/icons/proyecto/contact2.svg'

/*Amenities*/

import i_lobby from './../UI/icons/Amenities/Lobby.svg'
import i_hobbies from './../UI/icons/Amenities/Hobbies.svg'
import i_bicicletero from './../UI/icons/Amenities/bicicletero.svg'
import i_gym from './../UI/icons/Amenities/Gym.svg'
import i_saladejuegos from './../UI/icons/Amenities/salonjuegos.svg'
import i_saloncomunal from './../UI/icons/Amenities/saloncomunal.svg'
import i_bbq from './../UI/icons/Amenities/BBQ.svg'
import i_commercialarea from './../UI/icons/Amenities/CommercialArea.svg'
import i_crossfit from './../UI/icons/Amenities/crossfit.svg'
import i_yoga from './../UI/icons/Amenities/Yoga2.svg'
import i_books from './../UI/icons/Amenities/books.svg'
import i_estadia from './../UI/icons/Amenities/estadia.svg'
import i_massage from './../UI/icons/Amenities/massage.svg'
import i_massage2 from './../UI/icons/Amenities/massage2.svg'
import i_ping from './../UI/icons/Amenities/salonjuegos2.svg'
import i_playground from './../UI/icons/Amenities/Playground2.svg'
import i_game from './../UI/icons/Amenities/game.svg'
import i_guarderia from './../UI/icons/Amenities/guarderia.svg'
import i_pet from './../UI/icons/Amenities/pet.svg'

import i_lobby2 from './../UI/icons/Amenities/Lobby2.svg'
import i_hobbies2 from './../UI/icons/Amenities/Hobbies2.svg'
import i_bicicletero2 from './../UI/icons/Amenities/bicicletero2.svg'
import i_gym2 from './../UI/icons/Amenities/Gym2.svg'
import i_saladejuegos2 from './../UI/icons/Amenities/salonjuegos2.svg'
import i_saloncomunal2 from './../UI/icons/Amenities/saloncomunal2.svg'
import i_bbq2 from './../UI/icons/Amenities/BBQ2.svg'
import i_commercialarea2 from './../UI/icons/Amenities/CommercialArea2.svg'

import i_terrace from './../UI/icons/Amenities/Terrace.svg'
import i_lounge from './../UI/icons/Amenities/lounge.svg'
import i_lounge2 from './../UI/icons/Amenities/lounge2.svg'
import i_field from './../UI/icons/Amenities/field.svg'
import i_pool from './../UI/icons/Amenities/Pool.svg'
import i_sun from './../UI/icons/Amenities/sun.svg'
import i_jacuzzi from './../UI/icons/Amenities/Jacuzzi.svg'
import i_wifi from './../UI/icons/Amenities/wifi.svg'

/*POIS*/
import i_salud from './../UI/icons/POI/Salud.svg'
import i_comercio from './../UI/icons/POI/Comercio.svg'
import i_transporte from './../UI/icons/POI/Transporte.svg'
import i_otros from './../UI/icons/POI/Otros.svg'
import i_colegios from './../UI/icons/POI/Educacion.svg'
import i_parques from './../UI/icons/POI/Parques.svg'

import i_salud2 from './../UI/icons/POI/Salud2.svg'
import i_comercio2 from './../UI/icons/POI/Comercio2.svg'
import i_transporte2 from './../UI/icons/POI/Transporte2.svg'
import i_otros2 from './../UI/icons/POI/Otros2.svg'
import i_colegios2 from './../UI/icons/POI/Educacion2.svg'
import i_parques2 from './../UI/icons/POI/Parques2.svg'


export default {
    /*Sidebar*/
    'vias': i_vias,
    'vias2': i_vias2,
    'beneficios': i_beneficios,
    'beneficios2': i_beneficios2,
    'amenidades': i_amenidades,
    'amenidades2': i_amenidades2,
    'etapas': i_etapas,
    'etapas2': i_etapas2,
    'renders': i_renders,
    'recorridos': i_recor,
    'back': i_back,

    /*Sidebar*/
    'planimetria': i_planimetria,
    'planimetria2': i_planimetria2,
    'presentacion': i_presentacion,
    'presentacion2': i_presentacion2,
    'proyecto': i_proyecto,
    'proyecto2': i_proyecto2,
    'videos': i_videos,
    'videos2': i_videos2,
    'brochure': i_brochure,
    'brochure2': i_brochure2,
    'contacto': i_contacto,
    'contacto2': i_contacto2,

    /*Amenidades*/
    'Lobby': i_lobby,
    'Lobby2': i_lobby2,
    'Zona de niños': i_hobbies,
    'Zona de niños2': i_hobbies2,
    'Bicicleteros': i_bicicletero,
    'Bicicleteros2': i_bicicletero2,
    'Gimnasio y zona fitness': i_gym,
    'Gimnasio y zona fitness2': i_gym2,
    'Salón Juvenil': i_saladejuegos,
    'Salón Juvenil2': i_saladejuegos2,
    'Biblioteca y sala de juntas': i_saloncomunal,
    'Biblioteca y sala de juntas2': i_saloncomunal2,
    'Zona BBQ': i_bbq2,
    'Zona BBQ2': i_bbq2,
    'Zona Comercial': i_commercialarea,
    'Zona Comercial2': i_commercialarea2,
    'Terraza Aurora (Piso 31)': i_terrace,
    'Terraza Aurora (Piso 31)2': i_terrace,
    'Lounge juvenil': i_lounge2,
    'Lounge juvenil2': i_lounge,
    'Cancha Multifuncional': i_field,
    'Cancha Multifuncional2': i_field,
    'Zona Acúatica - Carril de Nado': i_pool,
    'Zona Acúatica - Carril de Nado2': i_pool,
    'Zona de Asoleación': i_sun,
    'Zona de Asoleación2': i_sun,
    'Asoleación - Jacuzzi Seco': i_jacuzzi,
    'Asoleación - Jacuzzi Seco2': i_jacuzzi,
    'Terraza WiFi': i_wifi,
    'Terraza WiFi2': i_wifi,
    'Centro de Actividad Física': i_gym2,
    'Centro de Actividad Física2': i_gym2,
    'Zona Crossfit al Aire Libre': i_crossfit,
    'Zona Crossfit al Aire Libre2': i_crossfit,
    'Deck de Yoga': i_yoga,
    'Deck de Yoga2': i_yoga,
    'Zona de Lectura al Aire Libre': i_books,
    'Zona de Lectura al Aire Libre2': i_books,
    'Zona de Estadía Aire Libre': i_estadia,
    'Zona de Estadía Aire Libre2': i_estadia,
    'Spa': i_massage2,
    'Spa2': i_massage,
    'Zona de Ping Pong': i_ping,
    'Zona de Ping Pong2': i_ping,
    'Piscina para Niños con Estadero': i_pool,
    'Piscina para Niños con Estadero2': i_pool,
    'Parque Infantil': i_playground,
    'Parque Infantil2': i_playground,
    'Habilidades Múltiples Infantiles': i_game,
    'Habilidades Múltiples Infantiles2': i_game,
    'Guardería': i_guarderia,
    'Guardería2': i_guarderia,
    'Zona Pet Friendly': i_pet,
    'Zona Pet Friendly2': i_pet,

    /**/
    "Salud": i_salud,
    "Salud2": i_salud2,
    "Comercio": i_comercio,
    "Comercio2": i_comercio2,
    "Transporte": i_transporte,
    "Transporte2": i_transporte2,
    "Otros": i_otros,
    "Otros2": i_otros2,
    "Colegios": i_colegios,
    "Colegios2": i_colegios2,
    "Parques": i_parques,
    "Parques2": i_parques2,
    'Entretenimiento': i_entretenimiento,
    'Entretenimiento2': i_entretenimiento2,
}